import { LicenseManagerService } from './../../shared/licensemanager-service/licensemanager.service';
import { NavParams } from 'ionic-angular/navigation/nav-params';
import { SPHCompany, SPHLoggedInUser, InputLimiterDirective } from './../../shared/shared';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { ToastController } from 'ionic-angular/components/toast/toast-controller';
import { AlertController } from 'ionic-angular/components/alert/alert-controller';

@Component({
    selector: 'lm-add-company',
    templateUrl: 'add-company.component.html',
})
export class AddCompanyComponent {
    @Input() public user: SPHLoggedInUser;

    private formGroup: FormGroup;

    constructor(private viewController: ViewController, private formBuilder: FormBuilder, navParams: NavParams, private licenseManagerService: LicenseManagerService, private toastController: ToastController, private alertController: AlertController) {

        const EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        this.formGroup = this.formBuilder.group({
            identnr: ['', Validators.required],
            name: ['', Validators.required],
            email: ['', [Validators.required, Validators.pattern(EMAIL_REGEXP)]],
            street: ['', Validators.required],
            city: ['', Validators.required],
            zip: ['', Validators.required],
        }, {
            // validator: CompanyDetailsComponent.matchPasswords
        });
        this.user = navParams.get('user');
    }

    public didTapSaveCompany() {
        const company = new SPHCompany();

        company.identnr = this.formGroup.value['identnr'];
        company.name = this.formGroup.value['name'];
        company.email = this.formGroup.value['email'];
        company.identnr = this.formGroup.value['identnr'];
        company.location = this.formGroup.value['zip'] + ' ' + this.formGroup.value['city'] + ', ' + this.formGroup.value['street'];

        this.licenseManagerService.postCompany(company, this.user.jwt).subscribe( (success) => {
            const toast = this.toastController.create({message: 'Firma erstellt', duration: 3000});
            toast.present();

            this.viewController.dismiss();
        }, (error) => {
            let message = error.message;
            if (error.error !== undefined && error.error.error !== undefined) {
                message = error.error.error.message;
            }

            const alert = this.alertController.create({
                title: 'Firma kann nicht angelegt werden.',
                message: 'Fehler vom Server: ' + message,
                buttons: [
                  {
                    text: 'OK',
                    role: 'cancel',
                  },
                ]
              });
            alert.present();
            });
    }

    public didTapAbort() {
        this.viewController.dismiss();
    }
}



// WEBPACK FOOTER //
// ./src/app/features/companyLicenseManagement/addCompanyComponent/add-company.component.ts